import type { SupportProfile, SupportSettings } from '../types/supportProfiles';

export const DEFAULT_SUPPORT_SETTINGS: SupportSettings = {
  touchpointSize: 0.5,
  minima: true,
  overhangs: true,
  overhangDensity: 3.92,
  overhangAngle: 18,
  stabilization: true,
  reinforcements: true,
  reinforcementDensity: 1.89
};

export const PRESET_PROFILES: SupportProfile[] = [
{
  id: 'preset-miniatures',
  name: 'Delicate Miniatures',
  description: 'Fine details, minimal marks',
  icon: 'miniature',
  settings: { touchpointSize: 0.35, minima: true, overhangs: true, overhangDensity: 4.6, overhangAngle: 15, stabilization: true, reinforcements: true, reinforcementDensity: 1.4 }
},
{
  id: 'preset-dental',
  name: 'Dental Models',
  description: 'High accuracy, clean surfaces',
  icon: 'tooth',
  settings: { touchpointSize: 0.45, minima: true, overhangs: true, overhangDensity: 4.2, overhangAngle: 20, stabilization: true, reinforcements: true, reinforcementDensity: 2.1 }
},
{
  id: 'preset-structural',
  name: 'Structural Parts',
  description: 'Strong supports, stability',
  icon: 'cog',
  settings: { touchpointSize: 0.65, minima: true, overhangs: true, overhangDensity: 3.2, overhangAngle: 25, stabilization: true, reinforcements: true, reinforcementDensity: 2.6 }
},
{
  id: 'preset-jewelry',
  name: 'Jewelry',
  description: 'Small features, clean finish',
  icon: 'ring',
  settings: { touchpointSize: 0.4, minima: true, overhangs: true, overhangDensity: 5.0, overhangAngle: 12, stabilization: false, reinforcements: true, reinforcementDensity: 1.6 }
},
{
  id: 'preset-general',
  name: 'General Purpose',
  description: 'Balanced settings for most models',
  icon: 'cube',
  settings: { touchpointSize: 0.55, minima: true, overhangs: true, overhangDensity: 3.5, overhangAngle: 20, stabilization: true, reinforcements: true, reinforcementDensity: 1.8 }
}];
